import { defineComponent as _defineComponent } from 'vue'
import {VPopover} from "@/components/v-tooltip";
import {PopoverTooltipPlacement} from "@/typings/PopoverTooltipPlacement";

type vTooltipProps = {
  tooltipPlacement?: PopoverTooltipPlacement;
  tooltipOffset?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vTooltip',
  props: {
    tooltipPlacement: { default: "top-end" },
    tooltipOffset: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { tooltipPlacement: PopoverTooltipPlacement, tooltipOffset: number };



return { __sfc: true,props, VPopover }
}

})